import { Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { Country } from "../../models/countries-interface";
import { AppContext } from "../../context/app-context";

import "./CountrySelect.scss";

interface ICountrySelectProps {
  countryFilter?: string[];
  onChange?: Function;
}

const CountrySelect = ({ countryFilter = [], onChange }: ICountrySelectProps) => {
  const [selectableCountries, setSelectableCountries] = useState<any[]>();
  const [prevSelectedCountry, setPrevSelectedCountry] = useState<Country>();
  const { profile, countries, isLoadingCountry: loading, selectedCountry, setSelectedCountry } = useContext(AppContext);
  const { Option } = Select;

  const onChangeCountry = ((country: string) => {
	if (onChange) {
	  var result = onChange();
	  if (!result) {
		return; // "stop propogation"
	  }
	}

    let sc = countries?.find(c => c.code && c.code.iv === country);
	setSelectedCountry(sc);
  })

  useEffect(() => {
    if (countries && profile && profile.Market) {
	  let country = profile.Market;
	  let userCountry = null;
	  let language: string = "en";
	  let countryName = '';
	  let filteredCountries: Country[] = [];

	  // filter and set countries
	  if (!selectableCountries) {
	    if (country === "All") {
		  const mappedItems = 
		    countries.map((v, i) => {
		      if (!countryFilter.includes(v.name[language])) {
				filteredCountries.push(v);

		        return (
			      <Option key={i.toString()} value={v.code.iv}>
			        {(v.name[language])}
				  </Option>
			    );
			  }
			  return null;
		    })
			.filter(x => x !== null);

		  setSelectableCountries(mappedItems);
		}
	  }

	  // update selected country based on filtered countries
	  if (!selectedCountry || !filteredCountries.includes(selectedCountry)) {
	    if (country === "All") {
		  userCountry = filteredCountries[0];
		} else {
		  userCountry = filteredCountries.find(c => c.code && c.code.iv === profile.Market);
		}
		countryName = userCountry?.name ? [language] ? userCountry.name[language] : '' : '';
		if (countryName) {
		  setSelectedCountry(userCountry);
		}
	  }

	  // track previously selected country
	  if (selectedCountry && (!prevSelectedCountry || selectedCountry.code?.iv !== prevSelectedCountry.code?.iv)) {
	    setPrevSelectedCountry(selectedCountry);
	  }
	}
  }, [profile, countries, selectedCountry, selectableCountries, loading, prevSelectedCountry, setSelectedCountry, countryFilter, Option]);

  return (
	<>
	  <Select
		className="country-select"
		onChange={onChangeCountry}
		value={selectedCountry?.code.iv}
		allowClear={false}
		loading={!selectableCountries || selectableCountries.length === 0}
	  >
	    {selectableCountries}
	  </Select>
	</>
  );
}

export default CountrySelect;

